import React, { FC } from 'react';
import { IMRBeaconSVGProps } from './icons.types';

const CircleOne: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <circle cx="16" cy="16" r="15.5" stroke="black" />
      <foreignObject x="10" y="8" width="16" height="16">
        <div>
          <span>1</span>
        </div>
      </foreignObject>
    </svg>
  );
};
export default CircleOne;
